import i18next from "src/i18n/config";

import { Theme } from "@mui/material";

export const chartHeight = 240;

/**
 * Minimum value to avoid log(0)
 */
export const LogZeroBuffer = 0.5;

export const TimeRangeOptions = [
    { label: i18next.t("pages:overviewPage.cards.eventChart.last7Days"), value: 7 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last14Days"), value: 14 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last30Days"), value: 30 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last60Days"), value: 60 },
];

export function getEventColors(theme: Theme) {
    return { notice: theme.palette.emteria.success, warning: theme.palette.emteria.warning };
}

type ChartEventLevel = "notice" | "warning";

export type ClickedPoint = {
    level: ChartEventLevel;
    epochMs: number;
    count: number;
    hasOverlappingEvents: boolean;
};
